import { headers } from './constants';
import { APIErrorResponse, isAPIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import Identity from './identity';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

/**
 * Arc XP Identity as provider
 *
 * Parameter exchange with Arc XP Identity as provider, this API will validate an active session on Arc XP Identity and respond with a URL containing state and code params. The sdk method is on charge to get the user redirected to the URL where should fall after successfully logged in.
 *
 * @param params
 * Arc XP Identity as provider returns response_type, scope, client_id, state, redirect_uri, code_challenge, code_challenge_method, and nonce (optional)
 *
 * @returns
 * A __Promise__. When successful, the user is redirected to a URL containing state and code params used to get logged in.
 *
 */

export const loginWithArcIdentityAsOIDCProvider = async (
  params: Record<string, string>
): Promise<APIErrorResponse | void> => {
  return fetch(
    `${Identity.apiOrigin}/identity/public/v2/oidc/provider/login?` + new URLSearchParams(params),
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${Identity.userIdentity.accessToken}`,
        ...headers
      }
    }
  )
    .then(JSONResponseHandler)
    .then(res => {
      if (isAPIErrorResponse(res)) {
        throw res;
      } else {
        window.location.href = res?.message;
      }
    });
};

export default loginWithArcIdentityAsOIDCProvider;
